import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { CapabilitiesMarketplaceResponseDataSchema } from "schema"
import z from "zod"

const getMarketplaceCapabilitiesQueryKey = () => ["capabilities", "marketplace"]

type Response = {
  data: z.infer<typeof CapabilitiesMarketplaceResponseDataSchema>
}

type Props = {
  enabled?: boolean
}

export const marketplaceCapabilitiesQuery = ({ enabled }: Props = {}) => {
  return queryOptions({
    queryKey: getMarketplaceCapabilitiesQueryKey(),
    queryFn: async () => {
      const response = await axios.get<Response>("/capabilities/marketplace")

      return response.data.data
    },
    enabled,
  })
}
